import { render } from "./parts.mobile.vue?vue&type=template&id=637f2736&ts=true"
import script from "./parts.mobile?vue&type=script&scoped=true&lang=ts"
export * from "./parts.mobile?vue&type=script&scoped=true&lang=ts"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__